// src/components/Contact.js
import React from 'react';

const Contact = () => {
    return (
        <section id="contact" className="section-content">
            <h2>Contact Me</h2>
            <div className="contact-list">
                <ul>
                    <li className="list-li"><a href="https://www.linkedin.com/in/deep1327007">LinkedIn</a></li>
                    <li className="list-li"><a href="https://twitter.com/Deep13270007">Twitter</a></li>
                    <li className="list-li"><a href="https://github.com/deep1327007">Github</a></li>
                </ul>
            </div>
        </section>
    );
};

export default Contact;
